// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_G1j","toggleWrap":"styles_toggleWrap__2zRml","content":"styles_content__1uiZz","selectAreaCode":"styles_selectAreaCode__2Adz4"};